export default "__VITE_ASSET__7fd31469__"